import { render, staticRenderFns } from "./ShipInfo.vue?vue&type=template&id=38ae67d4&scoped=true&"
import script from "./ShipInfo.vue?vue&type=script&lang=js&"
export * from "./ShipInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShipInfo.vue?vue&type=style&index=0&id=38ae67d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ae67d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VFlex,VLayout,VTab,VTabItem,VTabs})
